import { render, staticRenderFns } from "./setLeader.vue?vue&type=template&id=57e70b78&lang=pug"
import script from "./setLeader.vue?vue&type=script&lang=js"
export * from "./setLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports